import join from 'url-join';
import { SubPath } from '../config.json';

export function getWebAbsPath(path) {
    return join(SubPath, path.toString());
}
